import GroupDetail from './GroupDetail.vue';
import GroupDetailOverview from './detail/GroupDetailOverview.vue';
import GroupCreate from './create/GroupCreate.vue';

export default function GroupRoutes() {
  return [
    {
      path: ':id',
      component: GroupDetail,
      children: [ 
        {
          path: 'overview',
          component: GroupDetailOverview,
          name: 'groupOverview'
        }
      ]
    },
    {
      path: 'create',
      component: GroupCreate,
      name: 'groupCreate',
      meta: {
        detail: true
      }
    }
  ]
}
